module.exports = new __parcel__URL__("tabs_zh-cn.a5689916.webp").toString();